import AuthenticatedLayout from '@/Layouts/Auth/AuthenticatedLayout';
import DeleteUserForm from './Partials/DeleteUserForm';
import SetPasswordForm from './Partials/SetPasswordForm';
import UpdatePasswordForm from './Partials/UpdatePasswordForm';
import UpdateProfileInformationForm from './Partials/UpdateProfileInformationForm';
import {Head} from '@inertiajs/react';
import {useState} from 'react';
import {PageProps} from '@/types';
import PageLayout from "@/Layouts/PageLayout";

export default function Edit({auth, mustVerifyEmail, hasPassword, status}: PageProps<{
    mustVerifyEmail: boolean,
    hasPassword: boolean,
    status?: string
}>) {
    const [emailChanging, setEmailChanging] = useState(false);

    return (
        <PageLayout
            header={<h2 className="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">Profile</h2>}
        >
            <Head title="Profile"/>

            <div className="py-12 mx-3 md:mx-0">
                <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 space-y-6">
                    <div className="p-4 sm:p-8 bg-white dark:bg-gray-800 shadow rounded-lg">
                        <UpdateProfileInformationForm
                            mustVerifyEmail={mustVerifyEmail}
                            hasPassword={hasPassword}
                            status={status}
                            className="max-w-xl"
                            onEmailChanging={setEmailChanging}
                        />
                    </div>
                    {hasPassword && (
                        <div className="p-4 sm:p-8 bg-white dark:bg-gray-800 shadow rounded-lg">
                            <UpdatePasswordForm className="max-w-xl"/>
                        </div>
                    )}
                    {!hasPassword && !emailChanging && (
                        <div className="p-4 sm:p-8 bg-white dark:bg-gray-800 shadow rounded-lg">
                            <SetPasswordForm status={status} className="max-w-xl"/>
                        </div>
                    )}


                    <div className="p-4 sm:p-8 bg-white dark:bg-gray-800 shadow rounded-lg">
                        <DeleteUserForm user={auth.user} hasPassword={hasPassword} className="max-w-xl"/>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
